import * as tslib_1 from "tslib";
import { shouldShowAttachmentPreviewsForConversation } from 'owa-mail-attachment-previews';
import { getValidCouponIndexesForConversation } from 'owa-mail-coupon-peek';
import { getMailboxInfo } from 'owa-mail-mailboxinfo';
import { getUserConfiguration } from 'owa-session-store';
function mapBaseItemIdsToItemIds(baseItemIds) {
    var e_1, _a;
    var itemIds = [];
    try {
        for (var baseItemIds_1 = tslib_1.__values(baseItemIds), baseItemIds_1_1 = baseItemIds_1.next(); !baseItemIds_1_1.done; baseItemIds_1_1 = baseItemIds_1.next()) {
            var baseItemId = baseItemIds_1_1.value;
            var itemId = tslib_1.__assign({}, baseItemId);
            itemIds.push(itemId.Id);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (baseItemIds_1_1 && !baseItemIds_1_1.done && (_a = baseItemIds_1.return)) _a.call(baseItemIds_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return itemIds;
}
//TODO: 22724 itemId should be ClientItemId so we don't need this function to get mailboxInfo
function getConversationClientId(conversationType, tableView) {
    return { Id: conversationType.ConversationId.Id, mailboxInfo: getMailboxInfo(tableView) };
}
export default function mapConversationTypeToConversationItem(conversationType, tableView) {
    var itemIds = mapBaseItemIdsToItemIds(conversationType.GlobalItemIds);
    var conversationItem = {
        id: conversationType.ConversationId.Id,
        subject: conversationType.ConversationTopic,
        globalItemIds: itemIds,
        shouldShowAttachmentPreviews: getUserConfiguration().UserOptions.ShowInlinePreviews &&
            shouldShowAttachmentPreviewsForConversation(conversationType, tableView.tableQuery),
        validCouponIndexes: getValidCouponIndexesForConversation(conversationType, tableView.tableQuery),
        globalUnreadCount: conversationType.GlobalUnreadCount,
        size: conversationType.Size,
        clientId: getConversationClientId(conversationType, tableView),
    };
    return conversationItem;
}
//# sourceMappingURL=mapConversationTypeToConversationItem.js.map